import { httpClient } from "@services/api/httpClient";

export async function changeOfferStatus(id: number, status: 'OPEN' | 'CLOSED') {
  const response = await httpClient.post(`/offer/change-status`, { offerId: id, status });
  return response.data;
}